import {isPushymeMessageEvent, isTabsInteractionRequest} from '@/predicates/tabsInteraction';
import {TabsInteractionType} from '@/constants/tabsInteraction';
import {PushymeInteractionEventMap} from './INotificator'
import EventListener from '@/services/EventListener/EventListener';

class Notificator extends EventListener<PushymeInteractionEventMap> {
  constructor() {
    super()
    this._onMessage = this._onMessage.bind(this)
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', this._onMessage)
    }
  }

  protected _onMessage(event: MessageEvent) {
    const data = event.data
    if (!isTabsInteractionRequest(data)) {
      return
    }
    if (!isPushymeMessageEvent(data)) {
      return;
    }
    this.emit(TabsInteractionType.PushymeMessage, data.data)
  }
}

export default Notificator
